<template>
  <div>
    <el-container direction="vertical" class="layout-container">
      <HEAD></HEAD>
      <el-main class="el-main-ms">
        <!--图片层-->
        <main-plugin :img-src="imgSrc"></main-plugin>
        <!--核心战略品牌-->
        <h-brand-plugin></h-brand-plugin>
        <!--加盟地图-->
        <map-plugin></map-plugin>
        <!--文字描述-->
        <profile-plugin pro-title="关于陌上酒店集团" :img-pro-src="imgProSrc" :pro-text="proText" style="line-height:30px"></profile-plugin>
        <!--联系我们-->
        <contact-plugin></contact-plugin>
      </el-main>
      <FOOT></FOOT>
    </el-container>
  </div>
</template>

<script>
import HEAD from './Head'
import FOOT from './Foot'
import ContactPlugin from "@/components/ContactPlugin";
import MainPlugin from "@/components/MainPlugin";
import HBrandPlugin from "@/components/HBrandPlugin";

import MapPlugin from "@/components/MapPlugin";
import ProfilePlugin from "@/components/ProfilePlugin";
/*import VideoPlugin from "@/components/VideoPlugin";*/
export default {
  name: 'Home',
  metaInfo: {
      title: '陌上酒店集团官网', // set a title
      meta: [{             // set meta
          name: 'keyWords',
          content: '陌上酒店 陌上酒店集团 雅居东方 花开陌上 陌上轻雅 陌上轻居 陌上艺宿 陌上轻奢'
      }, {
          name: 'description',
          content: '立足酒店 多元发展，陌上集团，于2009年创立于郑州，是集酒店、装饰工程、家具、文娱投资于一体的综合性集团。'
      }]
  },
  data() {
    return {
      imgSrc: require('../assets/images/main-pgcs.png'),
      imgProSrc: require("../assets/images/mspp-pgcs.png"),
      proText: '<h2 style="color: rgb(124, 185, 186);text-align: center;">雅居东方 花开陌上</h2><p style="text-align: justify;">陌上酒店集团2017年源起杭州，2019年成为“一带一路驻华使节战略合作伙伴，跃进中国酒店集团规模榜TOP55。陌上旗下六大国潮风酒店品牌——陌上轻居、陌上轻雅、陌上轻奢、陌上艺宿、陌上雅居、陌上美庐酒店，聚焦“小而美、国潮风、玩跨界、锁下沉”四大战略，构建起极具市场竞争力与品牌号召力的多品牌战略矩阵。目前加盟300+门店，风靡全国25省，点亮300多个文化城市，实现下沉市场高量级布局。<n></n></p>' +
          '<p style="text-align: justify;">陌上旗下轻改酒店品牌——季居酒店，依托陌上超强运营优势,为老酒店升级一站式解决方案,共同构建起陌上酒店集团多品牌发展矩阵。' +
          '</p>'
    }
  },
  methods: {
  },
  components: {
    HEAD,
    FOOT,
    ContactPlugin,
    MainPlugin,
    HBrandPlugin,
    MapPlugin,
    ProfilePlugin
    /*VideoPlugin*/
  }
}
</script>

<style scoped>
  .layout-container {
    height: 100%;
  }
</style>
